import React from "react";
import { useSiteMetadata } from "../../hooks/use-site-metadata";

import OGImage from "../../assets/og.jpg";

const SEO = ({ type, metaTitle, metaDescription, robotsMetaTag, pathname, children, location = {}, canonicalUrl }) => {
  const { 
    title: defaultTitle,
    description: defaultDescription,
    robots: defaultRobots,
    image, siteUrl
  } = useSiteMetadata();

  const defaultPathname = location?.pathname || "";
  const formattedPathname = defaultPathname.endsWith("/") ? defaultPathname.slice(0, -1) : defaultPathname;
  const formattedCanonicalUrl = canonicalUrl ? `${siteUrl}/${canonicalUrl}`.replace(/\/+$/, "") : `${siteUrl}${formattedPathname}`;

  const seo = {
    title: metaTitle || defaultTitle,
    description: typeof metaDescription == "object" ? metaDescription?.metaDescription : metaDescription || defaultDescription,
    robots: robotsMetaTag || defaultRobots,
    image: `${siteUrl}${image}`,
    url: formattedCanonicalUrl
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots} />
      <link rel="canonical" href={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />
      {image ? <meta property="og:image" content={seo.image} /> : <meta property="og:image" content={OGImage} />}
      {children}
    </>
  );
};

export default SEO;